import { TagFormPage } from './TagFormPage';
export default TagFormPage;
